<template>
    <div class="full-width" v-loading="loading">
        <div class="title-box">
            <div>
                <span>{{i18n.tkey("lang_chat_group_files")}}</span>
            </div>

            <div>
                <span>{{fileNum}} {{i18n.tkey("lang_files_text")}} / {{fileSize}}</span>
            </div>

        </div>

        <ul class="data-ul" v-if="fileList.length > 0">
            <li v-for="(v, i) in fileList" :key="v.sysFilename" >
                <chatGroupFileRecord :obj="v" :roomId="roomId" />
            </li>
        </ul>

        <el-empty v-if="fileList.length == 0" :description="i18n.tkey('lang_none_group_file')" />
    </div>
</template>

<script setup>
    import chatGroupFileRecord from "@/components/shopopee/chat/chatGroupFileRecord"
    import {inject, onMounted, onBeforeMount, ref, computed} from "vue";
    import chatApi from "@/request/chatApi";
    import myUtil from "@/util/util";

    const props = defineProps(["roomId"])

    const i18n = inject("i18n")

    const loading = ref(false)

    const fileObj = ref({})
    const fileList = ref([])

    const fileNum = computed(() => {
        let num = 0

        if (null != fileObj.value && null != fileObj.value.num){
            num = fileObj.value.num
        }

        return num
    })

    const fileSize = computed(() => {
        let sizeText = "0 B"

        if (null != fileObj.value && null != fileObj.value.size){
            sizeText = myUtil.calcFileSize(fileObj.value.size)
        }

        return sizeText
    })

    function getFileList(){
        loading.value = true
        const request = chatApi.getChatFileList
        const params = request.getParams()

        params.roomid = props.roomId

        request.send(params, (res) => {
            loading.value = false

            if (res.code == 200){
                fileObj.value = res.detail
                fileList.value = res.detail.list
            }else{
                fileObj.value = {}
                fileList.value = []
            }
        })

    }

    onBeforeMount(() => {
        if (null != props.roomId){
            getFileList()
        }
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .title-box {
        text-align: left;
        margin: 0;
        background: #fefefe;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        border-bottom: 1px #DCDFE6 solid;
        line-height: 20px;
        color: #333;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        height: 40px;
    }

    .data-ul {
        margin-top: 0;
        padding-left: 0;
        list-style: none;
    }
</style>